import { SearchIcon, SparklesIcon } from "@heroicons/react/outline";
import { IModalProps, Modal } from "components/modal";
import { Link } from "react-router-dom";

export const RedirectCreatePromotionModal = ({ onClose, open }: IModalProps) => {
  return (
    <Modal title="" onClose={onClose} open={open}>
      <div className="flex flex-col w-full gap-y-2 divide px-4 text-base sm:max-w-xl">
        <div className="relative text-center">
          <p className="text-xl font-semibold leading-6">
            Would you like to create a new promotion or use the existing one?
          </p>
        </div>
        <div className="flex flex-col gap-y-4 py-3.5">
          <Link to={"/promotion/coupon/create/existing"}>
            <div className="p-4 border border-solid border-brand-500 rounded-lg cursor-pointer select-none flex items-center gap-x-3 active:opacity-85">
              <SearchIcon className="size-6 text-brand-500" />
              <div>
                <p className="text-lg text-brand-500 font-medium">Use Existing Condition</p>
                <p className="text-sm text-gray-500">Easily add more coupon codes to an existing condition.</p>
              </div>
            </div>
          </Link>
          <Link to={"/promotion/coupon/create/new"}>
            <div className="p-4 border border-solid border-brand-500 rounded-lg cursor-pointer select-none flex items-center gap-x-3 active:opacity-85">
              <SparklesIcon className="size-6 text-brand-500" />
              <div>
                <p className="text-lg text-brand-500 font-medium">Create New</p>
                <p className="text-sm text-gray-500">Set up a completely new condition or coupon codes from scratch.</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </Modal>
  );
};
